// Stable prefix of the one refusal every public auth surface reports. The frontend
// matches it to show the credential message, so the wording is a contract between the
// two apps rather than free text.
export const ACCOUNT_NOT_FOUND_MESSAGE_PREFIX = "No user found for email";
